import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

Vue.filter('NumberFormat', (value: any) => {
	if (!value) {
		return '0'
	}
	const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
	return intPartFormat
})

Vue.filter('time', (dataStr: string, pattern: any = 'YYYY-MM-DD HH:mm:ss') => {
	if (!dataStr) {
		return
	}
	return moment(dataStr).format(pattern)
})

Vue.filter('date', (dataStr: string, pattern: any = 'YYYY-MM-DD') => {
	if (!dataStr) {
		return
	}
	return moment(dataStr).format(pattern)
})

Vue.filter('datetime', (dataStr: string, pattern: any = 'YYYY-MM-DD HH:mm') => {
	if (!dataStr) {
		return
	}
	return moment(dataStr).format(pattern)
})

Vue.filter(
	'moment',
	(dataStr: string, pattern: any = 'YYYY-MM-DD HH:mm:ss') => {
		return moment(dataStr).format(pattern)
	}
)

Vue.filter('duration', (startTime: string, endTime: string) => {
	if (!(startTime && endTime && endTime > startTime)) {
		return
	}
	let start = moment(startTime)
	let end = moment(endTime)
	let hours = end.diff(start, 'hours')
	let minutes = end.diff(start, 'minutes')
	let seconds = end.diff(start, 'seconds')
	minutes = minutes % 60
	seconds = seconds % 60

	function zeroFit(time: string | number) {
		let match = time.toString().match(/^(\d)$/)
		if (match) {
			return `0${match[1]}`
		}
		return time
	}
	return `${zeroFit(hours)}:${zeroFit(minutes)}:${zeroFit(seconds)}`
})
